import styled from 'styled-components';

const p2 = 'var(--accent)';
const bg = 'var(--app-bg)';
const card = 'var(--surface-1)';
const border = 'var(--border-default)';
const inp = 'var(--input-bg)';
const white = 'var(--text-primary)';
const dgray = 'var(--text-secondary)';

export const PageWrapper = styled.div`
  min-height: 100vh;
  background: ${bg};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  font-family: 'Poppins', sans-serif;
  position: relative;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 420px;
`;

export const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  margin-bottom: 28px;
`;

export const LogoDot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: ${p2};
`;

export const LogoText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${p2};
  letter-spacing: 0.04em;
`;

export const ChatFab = styled.button`
  position: fixed;
  bottom: 28px;
  right: 28px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: var(--surface-2);
  border: 1px solid ${border};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  color: ${p2};
  z-index: 50;
  transition: background 0.2s;

  &:hover { background: var(--surface-3); }

  @media (max-width: 480px) {
    bottom: 20px;
    right: 20px;
  }
`;

export const Card = styled.div`
  background: ${card};
  border: 1px solid ${border};
  border-radius: 20px;
  padding: 28px 24px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: ${white};
    margin-bottom: 12px;
  }

  p.body {
    font-size: 13px;
    color: ${dgray};
    line-height: 1.7;
    margin-bottom: 8px;
  }

  @media (max-width: 480px) {
    padding: 22px 18px;
    border-radius: 16px;
    h2 { font-size: 16px; }
  }
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 20px;
  background: var(--surface-2);
  color: var(--warning);
  border: 1px solid ${border};
  margin-bottom: 16px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  width: fit-content;
`;

export const InfoBox = styled.div`
  background: var(--surface-2);
  border: 1px solid ${border};
  border-radius: 10px;
  padding: 12px 14px;
  margin: 18px 0 24px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;

  &:last-child { margin-bottom: 0; }

  i {
    font-size: 15px;
    color: var(--warning);
    flex-shrink: 0;
    margin-top: 1px;
  }

  span {
    font-size: 12px;
    color: ${dgray};
    line-height: 1.5;

    strong { color: ${white}; }
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${border};
  margin: 20px 0;
`;

export const Button = styled.button`
  width: 100%;
  padding: 13px;
  border-radius: 10px;
  background: ${p2};
  color: var(--text-on-accent);
  font-size: 14px;
  font-weight: 600;
  font-family: 'Poppins', sans-serif;
  border: none;
  cursor: pointer;
  margin-bottom: 10px;
  transition: background 0.2s;

  &:hover { background: var(--accent-hover); }
  &:disabled { background: var(--surface-3); color: var(--text-muted); cursor: not-allowed; }
`;

export const ButtonBack = styled.button`
  width: 100%;
  padding: 13px;
  border-radius: 10px;
  background: transparent;
  border: 1px solid ${border};
  color: ${dgray};
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.2s;

  &:hover { border-color: ${p2}; color: ${p2}; }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 10, 15, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 24px;
`;

export const ModalBox = styled.div`
  background: var(--surface-1);
  border: 1px solid ${border};
  border-radius: 16px;
  padding: 28px 24px;
  max-width: 360px;
  width: 100%;
  text-align: center;

  h3 {
    font-size: 15px;
    font-weight: 600;
    color: ${white};
    margin-bottom: 8px;
  }

  p {
    font-size: 12px;
    color: ${dgray};
    line-height: 1.6;
    margin-bottom: 18px;
  }
`;

export const ModalIcon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
  font-size: 19px;
  background: var(--surface-2);
  border: 1px solid ${border};
  color: ${({ warn }) => warn ? 'var(--warning)' : p2};
`;


export const ModalLabel = styled.label`
  font-size: 11px;
  font-weight: 500;
  color: ${dgray};
  margin-bottom: 5px;
  display: block;
  text-align: center;
`;

export const InputWrap = styled.div`
  position: relative;
  margin-bottom: 6px;
  text-align: left;

  svg {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: var(--input-placeholder);
  }
`;

export const Input = styled.input`
  width: 93%;
  padding: 12px 10px 8px 10px;
  background: ${inp};
  border: 1px solid ${border};
  border-radius: 8px;
  font-size: 12px;
  color: ${white};
  font-family: 'Poppins', sans-serif;
  outline: none;
  transition: border-color 0.2s;

  &::placeholder { color: var(--input-placeholder); }
  &:focus { border-color: ${p2}; }
`;

export const ErrorText = styled.span`
  font-size: 11px;
  color: var(--danger);
  display: block;
  margin-top: 4px;
  margin-bottom: 10px;
  text-align: left;
`;

export const ModalDivider = styled.hr`
  border: none;
  border-top: 1px solid ${border};
  margin: 14px 0;
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  background: ${inp};
  border: 1px solid ${border};
  border-radius: 8px;
  font-size: 12px;
  color: ${white};
  font-family: 'Poppins', sans-serif;
  outline: none;
  resize: none;
  min-height: 90px;
  transition: border-color 0.2s;

  &::placeholder { color: var(--input-placeholder); }
  &:focus { border-color: ${p2}; }
`;
